/**
 * @fileoverview Provide contextual hover help around caller-owned controls. The tooltip owns transient visibility and portal placement; the consuming workspace owns the explanation and its relationship to the action. Essential workflow state must remain available outside hover-only content.
 */

import React, { useState, useRef, useEffect } from 'react'
import { createPortal } from 'react-dom'

const tooltipStyle = {
    position: 'fixed',
    backgroundColor: 'var(--surface-900, #1e293b)',
    color: '#ffffff',
    padding: '0.4rem 0.65rem',
    borderRadius: '6px',
    fontSize: '0.8rem',
    fontWeight: 500,
    pointerEvents: 'none',
    zIndex: 9999,
    maxWidth: '280px',
    boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
    whiteSpace: 'pre-wrap'
}



function AppTooltip({ content, children, position = 'right' }) {
    const [visible, setVisible] = useState(false)
    const [coords, setCoords] = useState({ top: 0, left: 0 })
    const wrapperRef = useRef(null)

    useEffect(

    () => {
        if (!visible || !wrapperRef.current) return
        const rect = wrapperRef.current.getBoundingClientRect()
        const gap = 8
        let top, left
        switch (position) {
            case 'top':
                top = rect.top - gap
                left = rect.left + rect.width / 2
                break
            case 'bottom':
                top = rect.bottom + gap
                left = rect.left + rect.width / 2
                break
            case 'left':
                top = rect.top + rect.height / 2
                left = rect.left - gap
                break
            default: // right
                top = rect.top + rect.height / 2
                left = rect.right + gap
                break
        }
        setCoords({ top, left })
    }, [visible, position])

    if (!content) return children

    return (
        <span
            ref={wrapperRef}
            onMouseEnter={() => setVisible(true)}
            onMouseLeave={() => setVisible(false)}
            style={{ display: 'inline' }}
        >
            {children}
            {visible && typeof document !== 'undefined' && createPortal(
                <div style={{ ...tooltipStyle, top: coords.top, left: coords.left }}>
                    {content}
                </div>,
                document.body
            )}
        </span>
    )
}

export default AppTooltip
